// src/App.js
import React from 'react';
import GPUBrowser from './GPUBrowser';

function App() {
  return (
    <div>
      <GPUBrowser />
    </div>
  );
}

export default App;
